import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Modal, Spinner, Badge, Card, Button, Image } from "react-bootstrap";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';
import fallbackImg from '../assets/fotos/medida.png';

const API_URL = "https://facach.coop.hn/api";

const COMITES = [
  { code: "educacion", label: "Comité de Educación" },
  { code: "juventud",  label: "Comité de Juventud"  },
  { code: "genero",    label: "Comité de Género"    },
];

// Fallback estático por comité
const FALLBACK = {
  educacion: [
    { id: 1, title: "Encuentro Nacional de Comités de Educación 2024", event_date: "2024-01-10", image_url: null, description_html: "Se desarrolló el Encuentro Nacional con participación de cooperativistas.", committee: "educacion" },
    { id: 2, title: "Encuentro Nacional de Comités de Educación 2025", event_date: "2025-01-05", image_url: null, description_html: "Fortalecimiento de habilidades de liderazgo con enfoque cooperativo.",       committee: "educacion" },
  ],
  juventud: [
    { id: 3, title: "Capacitación en Liderazgo Juvenil Cooperativo",   event_date: "2025-12-10", image_url: null, description_html: "Evento nacional con participación de cooperativistas.",                      committee: "juventud"  },
    { id: 4, title: "Encuentro Nacional de Comités de Juventud",        event_date: "2026-01-05", image_url: null, description_html: "El comité impartió un taller intensivo de liderazgo juvenil.",              committee: "juventud"  },
  ],
  genero: [
    { id: 5, title: "Visita a Asilo de Ancianos La Inmaculada",         event_date: "2025-12-10", image_url: null, description_html: "Evento nacional con participación de cooperativistas.",                      committee: "genero"    },
    { id: 6, title: "Encuentro de Comités de Género",                   event_date: "2026-01-05", image_url: null, description_html: "Fortalecimiento de habilidades de liderazgo con enfoque cooperativo.",       committee: "genero"    },
  ],
};

const COMITE_COLORS = {
  educacion: "#1565c0",
  juventud:  "#2e7d32",
  genero:    "#8e3573",
};

function NewsCard({ item, onVerMas }) {
  const fechaLocal = item.event_date
    ? new Date(item.event_date).toLocaleDateString("es-HN", { year: "numeric", month: "long", day: "numeric" })
    : "";
  const color = COMITE_COLORS[item.committee] || "#1a3a6b";
  const comiteLabel = COMITES.find(c => c.code === item.committee)?.label || "";

  return (
    <Card className="shadow-sm h-100" style={{ borderTop: `4px solid ${color}`, borderRadius: 12 }}>
      {item.image_url ? (
        <Card.Img
          variant="top"
          src={item.image_url}
          alt={item.title}
          style={{ objectFit: "cover", height: 180 }}
          onError={e => { e.target.src = fallbackImg; }}
        />
      ) : (
        <div style={{
          height: 180, background: `linear-gradient(135deg, ${color}22, ${color}44)`,
          display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48,
        }}>📋</div>
      )}
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <Badge style={{ background: color, fontSize: 11 }}>{comiteLabel}</Badge>
          <small className="text-muted">{fechaLocal}</small>
        </div>
        <Card.Title className="fs-6 fw-bold" style={{ color: "#1a3a6b" }}>{item.title}</Card.Title>
        {item.summary && (
          <Card.Text className="text-muted" style={{ fontSize: 13, flex: 1 }}>
            {item.summary}
          </Card.Text>
        )}
        <Button
          variant="outline-primary"
          size="sm"
          className="mt-auto"
          style={{ borderColor: color, color: color }}
          onClick={() => onVerMas(item)}
        >Ver más</Button>
      </Card.Body>
    </Card>
  );
}

export default function NoticiasComite() {
  const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;

  const [eventos, setEventos]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [comite, setComite]         = useState("todos");
  const [q, setQ]                   = useState("");
  const [selected, setSelected]     = useState(null);
  const [showModal, setShowModal]   = useState(false);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          COMITES.map(async c => {
            try {
              const res  = await fetch(`${API_URL}/committee/${c.code}/events?limit=50`);
              const json = await res.json();
              if (json.ok && json.data?.length > 0) {
                return json.data.map(e => ({ ...e, committee: c.code }));
              }
              return FALLBACK[c.code].map(e => ({ ...e }));
            } catch {
              return FALLBACK[c.code].map(e => ({ ...e }));
            }
          })
        );
        setEventos(results.flat());
      } catch (err) {
        console.error("Error cargando eventos:", err.message);
        setEventos(Object.values(FALLBACK).flat());
      } finally { setLoading(false); }
    };
    fetchAll();
  }, []);

  const filtrados = eventos
    .filter(e => comite === "todos" || e.committee === comite)
    .filter(e =>
      e.title.toLowerCase().includes(q.toLowerCase()) ||
      (e.summary || '').toLowerCase().includes(q.toLowerCase())
    )
    .sort((a, b) => new Date(b.event_date) - new Date(a.event_date));

  return (
    <>
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Noticias y Eventos - FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">NOTICIAS Y EVENTOS</h1>
          <p className="banner-description">
            Actividades y eventos de los comités institucionales de FACACH
          </p>
        </div>
      </div>

      <Container className="py-5">

        {/* Filtros */}
        <Row className="g-3 align-items-end mb-4">
          <Col md={4}>
            <Form.Label style={{ fontWeight: 700, fontSize: 13, color: "#1a3a6b" }}>Buscar</Form.Label>
            <Form.Control
              placeholder="Título o palabra clave…"
              value={q}
              onChange={e => setQ(e.target.value)}
            />
          </Col>
          <Col md={4}>
            <Form.Label style={{ fontWeight: 700, fontSize: 13, color: "#1a3a6b" }}>Comité</Form.Label>
            <Form.Select value={comite} onChange={e => setComite(e.target.value)}>
              <option value="todos">Todos los comités</option>
              {COMITES.map(c => (
                <option key={c.code} value={c.code}>{c.label}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={4} className="text-md-end">
            <span style={{ fontSize: 13, color: "#7a8aaa", fontWeight: 500 }}>
              {filtrados.length} {filtrados.length === 1 ? 'resultado' : 'resultados'}
            </span>
          </Col>
        </Row>

        {/* Chips de comité */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 28 }}>
          {[{ code: "todos", label: "Todos" }, ...COMITES].map(c => (
            <button key={c.code} onClick={() => setComite(c.code)} style={{
              padding: "7px 18px", borderRadius: 20, fontSize: 13, fontWeight: 600,
              border: `1.5px solid ${comite === c.code ? (COMITE_COLORS[c.code] || "#1a3a6b") : "#dde3ef"}`,
              background: comite === c.code ? (COMITE_COLORS[c.code] || "#1a3a6b") : "#fff",
              color: comite === c.code ? "#fff" : "#7a8aaa",
              cursor: "pointer", fontFamily: "inherit", transition: "all 0.15s",
            }}>{c.label}</button>
          ))}
        </div>

        {/* Grid */}
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : filtrados.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#1a3a6b" }}>Sin resultados</div>
            <div style={{ fontSize: 13, marginTop: 4 }}>Intenta con otros filtros</div>
          </div>
        ) : (
          <Row className="g-4">
            {filtrados.map(e => (
              <Col md={4} key={`${e.committee}-${e.id}`}>
                <NewsCard
                  item={e}
                  onVerMas={item => { setSelected(item); setShowModal(true); }}
                />
              </Col>
            ))}
          </Row>
        )}
      </Container>

      <SocialBar position="right" top="35%" size={42} rounded={true} />

      {/* Modal detalle */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        {selected && (
          <>
            <Modal.Header closeButton style={{ borderBottom: `3px solid ${COMITE_COLORS[selected.committee] || "#1a3a6b"}` }}>
              <Modal.Title style={{ fontSize: 16, fontWeight: 800, color: "#1a3a6b" }}>
                {selected.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selected.image_url && (
                <img
                  src={selected.image_url}
                  alt={selected.title}
                  style={{ width: "100%", borderRadius: 10, marginBottom: 16, maxHeight: 300, objectFit: "cover" }}
                  onError={e => { e.target.style.display = "none"; }}
                />
              )}
              <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
                <Badge style={{ background: COMITE_COLORS[selected.committee] || "#1a3a6b" }}>
                  {COMITES.find(c => c.code === selected.committee)?.label}
                </Badge>
                {selected.event_date && (
                  <small className="text-muted">
                    📅 {new Date(selected.event_date).toLocaleDateString("es-HN", { year: "numeric", month: "long", day: "numeric" })}
                  </small>
                )}
              </div>
              {selected.description_html ? (
                <div dangerouslySetInnerHTML={{ __html: selected.description_html }} />
              ) : selected.summary ? (
                <p>{selected.summary}</p>
              ) : (
                <p className="text-muted">Sin descripción disponible.</p>
              )}
            </Modal.Body>
          </>
        )}
      </Modal>

      <FooterFacach />
    </>
  );
}